import { z } from 'zod'

// Angular `name` uses `Validators.required`, which treats a whitespace-only value as valid
// (non-empty) — so we require length >= 1 without trimming to match that behavior exactly.
export const productAddFormSchema = z.object({
  name: z.string().min(1, 'Product Name is required'),
  description: z.string().optional(),
  long_description: z.string().optional(),
  allow_dynamic_access_fee: z.boolean(),
  is_active: z.boolean(),
})

export const productEditBasicFormSchema = z.object({
  name: z.string().min(1, 'Product Name is required'),
  description: z.string().optional(),
  long_description: z.string().optional(),
  allow_dynamic_access_fee: z.union([z.literal(0), z.literal(1)]),
  is_active: z.union([z.literal(0), z.literal(1)]),
})

export type ProductAddFormValues = z.infer<typeof productAddFormSchema>
export type ProductEditBasicFormValues = z.infer<typeof productEditBasicFormSchema>
